export default __webpack_public_path__ + "static/media/no-scholarship.5285fe2b.png";